import { render, staticRenderFns } from "./SysFornecedorFabricanteAutocomplete.vue?vue&type=template&id=9a296e4e&scoped=true"
import script from "./SysFornecedorFabricanteAutocomplete.vue?vue&type=script&lang=js"
export * from "./SysFornecedorFabricanteAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./SysFornecedorFabricanteAutocomplete.vue?vue&type=style&index=0&id=9a296e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a296e4e",
  null
  
)

export default component.exports